import Vue from "vue";

const state = {
  swipePosFromLeft: undefined,
  changeBasemap: function(param){},
};

const getters = {};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
